/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "../request";
const mockUrl_0_0_0_0 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_0 = "";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 营销账户列表 的 **请求配置**
 *
 * @分类 商家API/商家账户
 * @请求头 `POST /erp/SupplyAccount/marketingAccountList`
 */
const postMarketingAccountListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/SupplyAccount/marketingAccountList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postMarketingAccountList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 营销账户列表 的 **请求函数**
 *
 * @分类 商家API/商家账户
 * @请求头 `POST /erp/SupplyAccount/marketingAccountList`
 */
export const postMarketingAccountList = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postMarketingAccountListRequestConfig, requestData),
    ...args
  );
};
postMarketingAccountList.requestConfig = postMarketingAccountListRequestConfig;
/**
 * 接口 营销账户流水日志 的 **请求配置**
 *
 * @分类 商家API/商家账户
 * @请求头 `POST /erp/SupplyAccount/marketingCashLogList`
 */
const postMarketingCashLogListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/SupplyAccount/marketingCashLogList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postMarketingCashLogList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 营销账户流水日志 的 **请求函数**
 *
 * @分类 商家API/商家账户
 * @请求头 `POST /erp/SupplyAccount/marketingCashLogList`
 */
export const postMarketingCashLogList = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postMarketingCashLogListRequestConfig, requestData),
    ...args
  );
};
postMarketingCashLogList.requestConfig = postMarketingCashLogListRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/openapi/erp/supplyAccount.js